module.exports = __webpack_public_path__ + "img/03.a0015349.png";